<template>
  <div>
    <el-row class="warp">
      <!--
            Form 组件提供了表单验证的功能，只需要通过 rule 属性传入约定的验证规则，并 Form-Item 的 prop 属性设置为需校验的字段名即可。具体可以参考官网：http://element.eleme.io/#/zh-CN/component/form
      -->
      <el-col :span="24" class="warp-main">
        <el-form ref="infoForm" :model="infoForm" :rules="rules" label-width="120px">
          <el-form-item label="封面图片" prop="bcoverimage">
            <el-upload class="avatar-uploader" :action="$Upload" :show-file-list="false" :headers="token" :data="ruleForm" :on-success="handleAvatarSuccess"
                       :before-upload="beforeAvatarUpload">
              <img v-if="infoForm.bcoverimage" :src="infoForm.bcoverimage" class="bcover-image" />
              <i v-else class="el-icon-plus avatar-uploader-icon plus-sign"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="新闻标题" prop="btitle">
            <el-input v-model="infoForm.btitle" placeholder="请输入新闻标题" style="width: 600px"></el-input>
          </el-form-item>
          <el-form-item label="关键词" prop="bkeywords">
            <el-input v-model="infoForm.bkeywords" placeholder="关键词，逗号分隔" style="width: 600px"></el-input>
          </el-form-item>
          <el-form-item label="新闻类型" prop="btype">
            <el-select v-model="infoForm.btype" placeholder="请选择文章分类" style="width: 600px">
              <el-option label="新闻资讯" :value="1"></el-option>
              <el-option label="会议预告" :value="2"></el-option>
              <el-option label="精彩回顾" :value="3"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="新闻摘要" prop="bsummary">
            <el-input v-model="infoForm.bsummary" placeholder="请输入摘要内容，不超过500字" :rows="4" type="textarea" maxlength="500" show-word-limit style="width: 600px"></el-input>
          </el-form-item>
          <el-form-item label="新闻内容" prop="bcontent">
             <div class="editor-container">
              <UE v-model="infoForm.bcontent" :config="config" id="ue1" ref="ue"></UE>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">确认提交</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import UE from '../../components/ue/ue.vue';
import { getBlogDeatil, editBlog, addBlog } from "../../api/api";

export default {
  data() {
    return {
      id: this.$route.params.id,
      infoForm: {
        btitle: "",
        bsubmitter: "",
        bcategory: "",
        bcontent: "",
        bcoverimage: "",
        bkeywords: "",
        btype: "",
        bsummary: "",
      },
      defaultMsg: '',
      config: {
        initialFrameWidth: null,
        initialFrameHeight: 350
      },
      editorOption: {},
      //表单验证  
      rules: {
        bcoverimage: [{ required: true, message: "请上传封面图片", trigger: "change" }],
        btitle: [{ required: true, message: "请输入标题", trigger: "blur" }],
        bkeywords: [{ required: true, message: "请输入关键词", trigger: "blur" }],
        btype: [{ required: true, message: "请选择新闻类型", trigger: "change" }],
        bsummary: [{ required: true, message: "请输入新闻摘要", trigger: "blur" }],
        bcontent: [
          { required: true, message: "请输入详细内容", trigger: "blur" }
        ]
      },
      // 上传组件相关配置
      token: {
        Authorization: "Bearer " + window.localStorage.Token
      },
      ruleForm: {
        type: 'blog' // 上传文件类型标识
      },
      beforeAvatarUpload(file) {
        const isJPG = file.type === "image/jpeg";
        const isPNG = file.type === "image/png";
        const isGIF = file.type === "image/gif";
        const isValidType = isJPG || isPNG || isGIF;
        const isLt2M = file.size / 1024 / 1024 < 1;

        if (!isValidType) {
          this.$message.error('上传图片只能是 JPG、PNG 或 GIF 格式!');
        }
        if (!isLt2M) {
          this.$message.error("图片大小不能超过 1MB!");
        }
        return isValidType && isLt2M;
      },
    };
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill;
    }
  },
  mounted() {
    this.getDeatil();
  },
  methods: {
    // 处理图片上传成功
    handleAvatarSuccess(res, file) {
      if (res.success) {
        // 设置图片显示URL
        this.infoForm.bcoverimage = this.$imageApi + res.response;
        this.$refs.infoForm.validateField('bcoverimage');
        this.$message({
          type: "success",
          message: "图片上传成功",
          duration: 2000
        });
      } else {
        this.infoForm.bcoverimage = ''
        this.$message({
          type: "error",
          message: res.msg || "图片上传失败",
          showClose: true
        });
      }
    },
    getDeatil() {
      //初始化
      var para = { id: this.id };
      getBlogDeatil(para).then(res => {
        // 确保所有字段都被正确初始化，避免响应式问题
        const responseData = res.data.response || {};
        this.infoForm = {
          btitle: responseData.btitle || "",
          bsubmitter: responseData.bsubmitter || "",
          // bcategory: responseData.bcategory || "技术博文",
          bcontent: responseData.bcontent || "",
          bcoverimage: responseData.bcoverimage || "",
          bkeywords: responseData.bkeywords || "",
          btype: responseData.btype || "",
          bsummary: responseData.bsummary || "",
        };
      }).catch(error => {
        console.error('获取博客详情失败:', error);
        this.$message({
          type: "error",
          message: "获取博客详情失败",
          showClose: true
        });
      });
    },
    onEditorReady(editor) { },
    onSubmit() {
      let content = this.$refs.ue.getUEContent(); // 调用子组件方法
      this.infoForm.bcontent = content;
      console.log("提交的内容:", content);
      //提交
      this.$refs.infoForm.validate(valid => {
        if (valid) {
          console.log(this.infoForm);
          var postPara = this.infoForm;
          if (this.id && this.id > 0) {
            postPara.bID = Number(this.id);
            editBlog(postPara).then(res => {
              if (res.data.success) {
                this.$notify({
                  type: "success",
                  message: "修改成功!",
                  duration: 3000
                });
                this.$router.replace(`/Blog/Blogs`);
              } else {
                var errorMsg = res.data.msg;
                this.$message({
                  type: "error",
                  message: errorMsg,
                  showClose: true
                });
              }
            });
          } else {
            addBlog(postPara).then(res => {
              if (res.data.success) {
                this.$notify({
                  type: "success",
                  message: "添加成功!",
                  duration: 3000
                });
                this.$router.replace(`/Blog/Blogs`);
              } else {
                var errorMsg = res.data.msg;
                this.$message({
                  type: "error",
                  message: errorMsg,
                  showClose: true
                });
              }
            });
          }
        } else {
          console.log("error submit!!", this.infoForm);
          return false;
        }
      });
    }
  },
  components: {UE},
};
</script>

<style scoped>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 120px;
    text-align: center;
  }
  .plus-sign{
    line-height: 120px !important;
  }
.warp {
  background: #fff;
  padding-top: 20px;
  width: 90%;
  margin: 0 auto;
}
.ql-container.ql-snow,
.ql-editor.ql-blank {
  min-height: 500px !important;
}
::v-deep .el-icon-plus, ::v-deep .el-upload, .bcover-image,
.avatar-uploader {
  width: 272px;
  height: 140px;
}
</style>
